import {
  GET_BUSINESS,
  CREATE_BUSINESS,
  BUSINESS_LOADING,
  DELETE_BUSINESS,
  BUSINESS_ERROR,
} from '../actions/types';

/**
 * maco-magsael-sc-939: Sales - Modification v4
 *
 */

const initialState = {
  businesslist: [],
  businessLoading: false,
  error: {},
};

//eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case BUSINESS_LOADING:
      return {
        ...state,
        businessLoading: true,
      };
    case GET_BUSINESS:
      return {
        ...state,
        businesslist: payload,
        businessLoading: false,
      };
    case CREATE_BUSINESS:
      return {
        ...state,
        businesslist: [payload, ...state.businesslist],
        businessLoading: false,
      };
    case BUSINESS_ERROR:
      return {
        ...state,
        error: payload,
        businessLoading: false,
      };
    case DELETE_BUSINESS:
      return {
        ...state,
        businesslist: state.businesslist.filter(
          (business) => business._id !== payload,
        ),
        businessLoading: false,
      };
    default:
      return state;
  }
}
